import React, { createContext, useState, useContext, useEffect, useRef, useCallback } from 'react';
import { io } from 'socket.io-client';

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

const SERVER_DOMAIN = process.env.REACT_APP_BACKEND_HOST;

export const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [isLoadingUser, setIsLoadingUser] = useState(false);
  const [token, setToken] = useState(null);
  const [socket, setSocket] = useState(null);
  const socketRef = useRef(null);
  const isHandlingSessionReplacementRef = useRef(false);

  const handleSessionReplaced = useCallback(() => {
    if (isHandlingSessionReplacementRef.current) return;
    isHandlingSessionReplacementRef.current = true;

    if (socketRef.current) {
      socketRef.current.removeAllListeners();
      socketRef.current.disconnect();
      socketRef.current = null;
    }

    setSocket(null);
    setUserInfo(null);
    setToken(null);
    localStorage.removeItem('userInfo');
    localStorage.removeItem('isAuthenticated');

    window.location.href = '/login';
  }, []);

  useEffect(() => {
    if (!userInfo) {
      if (socketRef.current) {
        socketRef.current.removeAllListeners();
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      setSocket(null);
      return;
    }

    const nextSocket = io(SERVER_DOMAIN, {
      withCredentials: true,
    });

    nextSocket.on('session-replaced', handleSessionReplaced);
    socketRef.current = nextSocket;
    setSocket(nextSocket);

    return () => {
      nextSocket.off('session-replaced', handleSessionReplaced);
      nextSocket.disconnect();
      if (socketRef.current === nextSocket) {
        socketRef.current = null;
      }
    };
  }, [userInfo, handleSessionReplaced]);

  return (
    <UserContext.Provider value={{ 
      userInfo, 
      isLoadingUser, 
      setUserInfo, 
      setIsLoadingUser, 
      token, 
      setToken, 
      socket 
    }}>
      {children}
    </UserContext.Provider>
  );
};

